window.$ = require("jquery");

var slick = require('slick-carousel')

const baguetteBox = require('baguettebox.js');

var jquery_ui = require('webpack-jquery-ui');
var jquery_ui_css = require('webpack-jquery-ui/css');


$(function(){   

    // Activer btn-scroll-top � X scroll
    $(window).scroll(function(){
        var limit_height = 200;
        var scroll = window.pageYOffset;

        if(scroll > limit_height){
            btnScrollTopOn()
        }else{
            btnScrollTopOff()
        }
    });

    // toggle search form
    $('#js-search-btn').click(function(){
      $('#js-search-form').toggleClass('search-form--active')
      setTimeout(function(){
          $('#js-search-input').focus()
      }, 100)
    })
   
    function btnScrollTopOn(){
        $('#btn-scroll-top').addClass('scroll-top-actif');
    }
    function btnScrollTopOff(){
        if($('#btn-scroll-top').hasClass('scroll-top-actif')){
            $('#btn-scroll-top').removeClass('scroll-top-actif');
        }
    }        

    // burger menu
    if(($('.hamburger').length) > 0){
        $('.hamburger').click(function(){
            if($('header').hasClass('nav-active')){
                burgerMenuOff()
                btnScrollTopOn()                
            }else{
                burgerMenuOn()
                btnScrollTopOff()
            }
        });        
    }
    
    function burgerMenuOn(){
        $('.hamburger').addClass('is-active')
        $('header').addClass('nav-active')
    }
    function burgerMenuOff(){
        $('.hamburger').removeClass('is-active')
        $('header').removeClass('nav-active')

    }

    // anim scroll top
    $('#btn-scroll-top').click(function(){
        $('body, html').animate({scrollTop:0}, 300);
        $(this).blur()
    });
    
    //Gestion events scroll down/up
    var lastScrollTop = 0;
    var header_height = $('.header')[0].clientHeight    
    $(window).scroll(function(event){
        var scrollTop = $(this).scrollTop();
        if (scrollTop > lastScrollTop){
            // scroll down
            $('.header').css("top", "-" + header_height + "px")
            burgerMenuOff()
            btnScrollTopOff()
        } else {
            // scroll up
            $('.header').css("top", "0")
            btnScrollTopOn()
        }
        lastScrollTop = scrollTop;
    });

    // Fiche Produit - Technos Ravelli description
    if(($('[data-techno-i]').length) > 0){ 
        $('[data-techno-i]').each(function(i){
            $(this).click(function(){

                $('[data-techno-i]').removeClass('active')
                $(this).addClass('active')

                var iteration = i + 1
                var content = $('[data-techno-content-' + iteration + ']').html()
                var cible = $('[data-description-wrapper]')
                cible.empty()
                cible.append(content)
            })  
        });
    }
    
    //Slider banniere homepage
    if(($('[data-slider-banner]').length) > 0){    
        $('[data-slider-banner]').slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            autoplay:true,
            autoplaySpeed : 3500,
        });
    }
    
    //Slider homepage actus
    if(($('[data-slider-actus]').length) > 0){
        $('[data-slider-actus]').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            autoplay:false,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      adaptiveHeight: true
                    }
                  },
              ]
        });
    }
 
    if(($('.realisations-wrap').length) > 0){
        baguetteBox.run('.realisations-wrap');
    }
    
        //Slider photos produitFiche
    if(($('[data-slider-photosproduit]').length) > 0){
        $('[data-slider-photosproduit]').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            speed: 300,
            autoplay:false,
            lazyLoad:'progressive',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      adaptiveHeight: true
                    }
                  },
              ]
        });
    }

    // Gestion slider marques (responsive < 480)
    if(($('#slider-marques-entreprise').length) > 0){
        if (window.matchMedia("(max-width: 480px)").matches) {
            enableSliderMarques();
        }
        window.addEventListener("orientationchange", function(){
            if (window.matchMedia("(max-width: 480px)").matches) {
                $('#slider-marques-entreprise').slick("unslick"); 
            }else{         
                enableSliderMarques();   
            }
        }, false)      

        function enableSliderMarques(){
            $('#slider-marques-entreprise').slick({
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                autoplay: false,
                responsive: [                    
                        {
                        breakpoint: 320,
                        settings:{
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            autoplay: true,
                        }
                    }
                ]
            });
        }  
    }

    //Gestiont filtre gammes
    if(($('#filtre-gammes').length) > 0){
        if(($('.js-gammes-childs').length) > 0){

            //On set les heights des blocs parents au load (permet l'anim)
            $('.js-gammes-childs').each(function(i){
                var blocHeight = $(this)[0].scrollHeight
                $(this).css("height", blocHeight)
            })

            // Gestion ouverture/fermeture du bloc parent
            $('.js-gamme-item').click(function(el, i){
                $(this).each(function(i){
                    var gammeEnfant = $(this.nextElementSibling)
                    if($(this).hasClass('js-opened'))
                    {
                        $(this).removeClass('js-opened')
                        if(($(gammeEnfant).length) > 0){                        
                            gammeEnfant.css("height", "0")
                        }
                    }
                    else
                    {
                        $(this).addClass('js-opened')
                        if(($(gammeEnfant).length) > 0){  
                            var blocHeightEnfant = gammeEnfant[i].scrollHeight     
                            gammeEnfant.css("height", blocHeightEnfant)
                        }
                    }
                });
            });

            //Gestion actif/inactif des items enfants & de leurs inputs
            $('.js-gamme-child-item').click(debounce(function(el){
                $(this).each(function(i){

                    var parent = $(this)[0].parentElement 
                    var parents_and_siblings = getSiblings(parent);            
                    var is_desactivated = 'is-desactivated';
                    
                    if (parent.classList.contains('is-child-parent'))
                    {                        
                        for (let i=0; i < parents_and_siblings.length; i++)
                        {
                            var gamme = parents_and_siblings[i]
                            var label = gamme.getElementsByTagName("label")[0]
                            var gammeId = label.dataset['gammeId']
                            var parentLabel = label.parentElement

                            if (! (
                                    (! ($(parentLabel).hasClass('is-child-parent')) ) && 
                                    (! ($(label).hasClass('js-gamme-active'))) && 
                                    (! ($(label).hasClass(is_desactivated)))
                                ))
                            {
                                toggleGammeActive($(label), gammeId)
                            }
                                                        

                            if ($(label).hasClass(is_desactivated))
                            {
                                $(label).removeClass(is_desactivated)
                            } else {
                                $(label).addClass(is_desactivated)
                            }   
                            
                        }                        
                    }
                    else
                    {                        
                        if (! ($(this).hasClass(is_desactivated)) )  
                        {
                            var gammeId = $(this).data("gammeId")
                            toggleGammeActive($(this), gammeId)
                        }
                    }     
                })
            }, 300))

            function toggleGammeActive(elem, gammeId){
                if (elem.hasClass('js-gamme-active')) {
                    elem.removeClass('js-gamme-active')
                    $('#input-gamme-' + gammeId).val('0')
                    triggerEventChange()                    
                } else {
                    elem.addClass('js-gamme-active')
                    $('#input-gamme-' + gammeId).val('1')
                    triggerEventChange()
                }
            }
        }
        
    }       
    
    //Appel JqueryUI 
    if((($('.listing-filtre').length) > 0) || (($('#modalMessage').length) > 0)){        
        jquery_ui
        jquery_ui_css
    }

    //gestion input range - prix
    if(($('#input-range-prix').length) > 0){
        var input_range_prix = $('#input-range-prix')
        var divAttributes = $('#js_attributs_produits')
        var prix_max = divAttributes.data('prixMax')    
        input_range_prix.slider({
            range: true,
            min: 0,
            max: prix_max,
            values: [ 0, prix_max ],
            step: 10,
            slide: function(event, ui){ setLabelPrix() },
            change: function(event, ui){ setLabelPrix(), setInputValuePrix(), triggerEventChange() }
          })
        var valuesPrix = input_range_prix.slider( "option", "values" )
        var rangeLabelPrix = input_range_prix[0].previousElementSibling
        setLabelPrix()
        setInputValuePrix()

        function setLabelPrix(){
            rangeLabelPrix.innerHTML = valuesPrix[0] + " &euro; - " + valuesPrix[1] + " &euro;"
        }
        function setInputValuePrix(){
            $('#input-prix-min').val(valuesPrix[0])
            $('#input-prix-max').val(valuesPrix[1])
        }
        
    }

    //gestion input range - puissance
    if(($('#input-range-puissance').length) > 0){
        var divAttributes = $('#js_attributs_produits');
        var puissance_min = divAttributes.data("puissanceMin")
        var puissance_max = divAttributes.data("puissanceMax")
        var input_range_puissance = $('#input-range-puissance')
        input_range_puissance.slider({
            range: true,
            min: puissance_min,
            max: puissance_max,
            values: [ puissance_min, puissance_max ],
            step: 1,
            slide: function(event, ui){ setLabelPuissance() },
            change: function(event, ui){ setLabelPuissance(), setInputValuePuissance(), triggerEventChange() }
          })
        var valuesPuissance = input_range_puissance.slider( "option", "values" )
        var rangeLabelPuissance = input_range_puissance[0].previousElementSibling
        setLabelPuissance()
        setInputValuePuissance()

        function setLabelPuissance(){
            rangeLabelPuissance.innerHTML = valuesPuissance[0] + "kW - " + valuesPuissance[1] + "kW"            
        }
        function setInputValuePuissance(){
            $('#input-puissance-min').val(valuesPuissance[0])
            $('#input-puissance-max').val(valuesPuissance[1])
        }
    }

    function triggerEventChange(){
        $('#input-prix-max').trigger('change')
    }

    //Filtre AJAX 
    if(($('.listing-filtre').length) > 0){
        $(".js-input-filtre").each(function(el, i) {
            $(this).change(()=>{

                $('#filtre-results')[0].innerHTML = "Chargement..."

                setTimeout(function(){
                    let params = "gammeId=" + $('#input-gamme-id')[0].value
                    params += "&prixMin=" +  $('#input-prix-min')[0].value
                    params += "&prixMax=" +  $('#input-prix-max')[0].value
                    params += "&puissanceMin=" +  $('#input-puissance-min')[0].value
                    params += "&puissanceMax=" +  $('#input-puissance-max')[0].value
                    
                    let inputs = $('#filtre-form')[0].elements
                    let array = []
                    for(let i = 0; i < inputs.length; i++){
                        var input = inputs[i]
                        if((input.dataset.catId) && (input.value == 0)){
                            
                            array.push(input.dataset.catId)
                        } 
                    }

                    array = $.param({
                        excluded_categories: array,
                    })

                    params += "&" + array;
                    

                    let xhr = new XMLHttpRequest();                
                    xhr.onreadystatechange = ()=>{
                        if((xhr.readyState == 4) && (xhr.status == 200)){
                            $('#filtre-results')[0].innerHTML = xhr.responseText
                        }
                    }
                    xhr.open('POST', $('#filtre-form')[0].action, true);                 
                    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                    xhr.send(params);
                }, 100)

            })
        })
    }

    /**
     * Get siblings of an element
     * @param  {Element} elem
     * @return {Object}
     */
    var getSiblings = function (elem) {
        var siblings = [];
        var sibling = elem.parentNode.firstChild;
        for ( ; sibling; sibling = sibling.nextSibling ) 
        if ( sibling.nodeType == 1 )
            siblings.push( sibling );
        return siblings;
    }

    /*
    * Initie un d�lai sur un �venement pour �viter le spam
    */
    function debounce(callback, delay){
        var timer;
        return function(){
            var args = arguments;
            var context = this;
            clearTimeout(timer);
            timer = setTimeout(function(){
                callback.apply(context, args);
            }, delay)
        }
    }

    //Google map API
    if(($('#map-canvas').length) > 0){
        var markerMe;
        var MY_MAPTYPE_ID = 'custom_style';
        var map;
        var bulles = {};
        var contentInfoBox ='<div class="map-infobox">'+
                                '<img src="../Public/Images/site/logo.png" alt="Logo Eco Energies Services - Reims">'+
                                '<h2 class="titre-3" style="margin-bottom:4px;">Eco-Energies Services</h2>'+
                                '<a href="https://www.google.com/maps/place/ECO-ENERGIES+SERVICES/@49.2716388,4.0262015,15z/data=!4m2!3m1!1s0x0:0xf1d7299386ae8a11?ved=2ahUKEwiqyc7Uw5ffAhULKBoKHQ-_BG8Q_BIwCnoECAYQCA"'+
                                    'title="Voir sur Google Maps" target="_blank">23 Rue de Neufch&acirc;tel, 51100 Reims'+
                                '</a>'
                            '</div>';
        

        function initialize() {
            var style = [
                {
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e4e4e4"
                    }
                  ]
                },
                {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "color": "#2e2e2e"
                    },
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#2e2e2e"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.stroke",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#bdbdbd"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#cdcdcd"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#8a8a8a"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#8a8a8a"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e6e6e6"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#858585"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#d6d6d6"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#9d9d9d"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                }
              ];
            var initpos = new google.maps.LatLng(49.272999,4.026126);
            var mapOptions = {
                zoom: 15,
                center: initpos,
                disableDefaultUI:false,
                scrollwheel : false,
                mapTypeId: MY_MAPTYPE_ID
            };
            map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

            var styledMapOptions = {
                name: 'Custom Style'
            };

            var customMapType = new google.maps.StyledMapType(style, styledMapOptions);

            map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

            addMarkers();
        }

        function addMarkers(){

            var pos = new google.maps.LatLng(49.271653,4.026126);
            var icon_url = "../Public/Images/site/map-pin.png"
            //var icon_hover_url = get_Url_Image("site/rond_hover.png");
            
            var marker = new google.maps.Marker({
                position: pos,
                map: map,
                animation: google.maps.Animation.DROP,
                title: '23 rue de Neufchatel, 51100 REIMS',
                icon: icon_url,
            });

            var infowindow = new google.maps.InfoWindow({
                content: contentInfoBox
              });
            marker.addListener('click', function() {
                infowindow.open(map, marker);
            });

                
        };
      

        $(function(){
            initialize()
        });
    }  

});






